export enum TaskStatus {
    Open = "open",
    Responded = "responded"
}